<template>
  <b-modal
    id="package-class-event-modal"
    :title="dateTimeLabel"
    hide-footer
    @shown="onShown"
    @hidden="onHidden"
  >
    <div v-if="!!event">
      <h5 class="mb-0">
        {{ event.title }}
      </h5>
      <p class="text-muted">{{ typeLabel }}</p>
      <p v-if="event.extendedProps.theme">
        <i class="fa fa-fw fa-info-circle text-muted"></i>
        {{ event.extendedProps.theme }}
      </p>
      <p v-if="getStaffUsers(event).length > 0">
        <strong class="d-block">{{ trans('staff') }}</strong>
        <span v-for="(user, index) in getStaffUsers(event)" :key="index" class="d-block">
          <i class="fa fa-fw fa-chalkboard-teacher"></i>
          {{ user.name }}
        </span>
        <span v-if="getStaffUsers(event).length == 0">
          {{ trans('none') }}
        </span>
      </p>
      <p v-if="event.extendedProps.locations && event.extendedProps.locations.filter(loc => loc.type !== 'staff').length > 0">
        <strong class="d-block">{{ trans('location' + (event.extendedProps.locations.length > 1 ? 's' : '')) }}</strong>
        <span v-for="(location, index) in event.extendedProps.locations.filter(loc => loc.type !== 'staff')" :key="index" class="d-block">
          <i class="fa fa-fw fa-map-marker-alt"></i>
          <span>{{ location.name }}</span>
          <small v-if="!!location.address" class="text-muted">{{ location.address }}</small>
        </span>
      </p>
      <p v-if="!!recipientForms && recipientForms.length > 0">
        <strong>{{ trans('registration') }}</strong>
        <span v-for="recipient_form in recipientForms" :key="'rf'+recipient_form.id" class="d-block">
          <b-button variant="link" size="sm" :href="recipient_form.page_url" target="_blank">
            <i class="fa fa-fw fa-file-alt"></i>
            <span>{{ recipient_form.name }}</span>
            <small><i class="fa fa-fw fa-external-link-alt"></i></small>
          </b-button>
        </span>
      </p>
    </div>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      event: Object,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        busy: false,
        error: null,
      }
    },
    computed: {
      dateTimeLabel() {
        if (!this.event) return null
        return `${moment(this.event.start).format('LL')}, ${moment(this.event.start).format('LT')} ${this.event.end ? (' - ' + moment(this.event.end).format('LT')) : ''}`
      },
      typeLabel() {
        if (!this.event) return null
        if (this.event.extendedProps.is_zoom_class) return trans('zoom_class');
        return trans('class_type_' + this.event.extendedProps.type)
      },
      recipientForms() {
        if (!this.event) return null
        return this.event.extendedProps.recipient_forms || null
      },
    },
    methods: {
      getStaffUsers(event) {
        let emails = []
        let users = _.reduce(event.extendedProps.staff_for_edit || [], (users, user) => {
          if (emails.index(user.email) === -1) {
            users.push(user)
            emails.push(user.email)
          }
          return users
        }, [])
        return _.reduce(event.extendedProps.permission_staff || [], (users, user) => {
          if (emails.index(user.email) === -1) {
            users.push(user)
            emails.push(user.email)
          }
          return users
        }, users)
      },
      onShown() {
      },
      onHidden() {
        this.busy = false
        this.error = null
      },
    },
    mounted() {
      window.packageClassEventModal = this
    },
  }
</script>
